import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from '../shared.service';
import { map, Observable, Subject, throwError } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
    }),
};

@Injectable({
    providedIn: 'root',
})
export class SearchService extends SharedService {
    constructor(public http: HttpClient) {
        super(http, 'artist');
    }

    //Información de todos los ecosistemas, eventos y ofertas

    getTypeInformation(tipo: number) {
        //console.log(tipo)
        switch (tipo) {
            case 1:
                return this.getAll('eventos', '/events');
            case 2:
                return this.getAll('eventos', '/offers');
            case 3:
                return this.getAll('artistas', '/artist', {page: 1, limit: 10});
            case 4:
                return this.getAll('collective', '/collective', {page: 1, limit: 10});
            case 5:
                return this.getAll('empresas', '/business', {page: 1, limit: 10});
            case 6:
                return this.getAll('espacios', '/espacio', {page: 1, limit: 10});
            default:
                return throwError(() => new Error('Error: Problema con los datos'));
        }
    }

    getEcosystemByType(tipo: number): string {
        switch (tipo) {
            case 3:
                return 'artistas'; // Individual
            case 4:
                return 'collective'; // Colectivo
            case 5:
                return 'empresas'; // Público
            case 6:
                return 'espacios'; // educativo
            default:
                return 'artistas';
        }
    }

    private ecosystemRouteMap: { [key: string]: string } = {
        artistas: 'artist',
        collective: 'collective',
        empresas: 'business',
        espacios: 'espacio'
        // agregar más
    };

    getEcosystemRoute(ecosystem: string): string {
        return this.ecosystemRouteMap[ecosystem] || 'artist';
    }

    //Ecosistemas

    getBuscarGeneralMeili(tipo: number): Observable<any> {
        let mainPath = '';
        let subPath = '';
        if (tipo === 3) {
            mainPath = this.urls.artistas;
            subPath = '/artist';
        }
        /*if(tipo === 3) {
            mainPath = this.urls.colectivo;
            subPath = 'collective';
        } */
        return this.http.post<any>(mainPath + subPath + '/searchFilter', httpOptions); //?page=' + page + ' &size=' + size,
        //JSON.stringify(data), httpOptions);
    }

    askFollowing(data: any, tipo: number): Observable<Object[]> | undefined {
        switch (tipo) {
            case 3:
                return this.http.post(this.urls.artistas + `/artist/0/following`, data, httpOptions).pipe(map((response: any) => response as Object[]));
        }
    }

    //this.searchService.getAll(this.ecosystem, `/${this.profileService.getEcosystemRoute(this.ecosystem)}/0`

    getAllSubareas(): Observable<any> {
        return this.http.get<any>(`${this.urls.lenguaje}/getParametersDetails/188/consult`).pipe(map((response) => response));
    }

    getAreas(): void {
        this.getParam(185);
    }

    //Eventos y ofertas

    getEventInfo(id: any) {
        return this.http.get<any>(this.urls.eventos + `/events/${id}/detailInfo`, httpOptions);
    }

    getOfferInfo(id: any) {
        return this.http.get<any>(this.urls.eventos + `/offers/${id}/detailInfo`, httpOptions);
    }
}
